require('../../modules/es6.object.is-frozen');
module.exports = require('../../modules/$.core').Object.isFrozen;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/~/core-js/library/fn/object/is-frozen.js
 ** module id = 453
 ** module chunks = 0
 **/